<template>
    
           
            <div class="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
                <a href="/" class="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <span class="fs-5 d-none d-sm-inline">Menu</span>
                </a>
                <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
                    
                    <li v-for="(item, index) in Menu" v-bind:key="item" v-bind:index="index">
                        <a v-bind:href="'#submenu'+item.nidOpcionesSistemas"  data-bs-toggle="collapse" class="nav-link px-0 align-middle">
                             <i v-bind:class="['fs-4 bi-speedometer2 nav-icon', item.sIcon]"> </i>
                              <span class="ms-2 d-none d-sm-inline">{{item.sDescripcionOpcion}}</span>
                               <i class="right fas fa-angle-left ms-2" ></i>
                               </a>
                             
                        <ul 
                        v-for="(subitem, subindex) in item.olDet" v-bind:key="subitem" v-bind:index="subindex"
                        class="collapse nav flex-column ms-2"  v-bind:id="'submenu'+item.nidOpcionesSistemas"  >
                            <li class="w-100" >
                                <router-link class="nav-link px-0" v-bind:to="subitem.sUrlVista" > 
                                <i  v-bind:class="['fs-4 bi-speedometer2 nav-icon', subitem.sIcon]"> </i>
                                <span class="d-none d-sm-inline ms-2">{{subitem.sDescripcionOpcion}}</span>  </router-link>
                            </li>
                           
                        </ul>
                    </li>
                    <li  style="cursor: pointer;">
                        <a class="nav-link px-0 align-middle" @click="Logout()">
                             <i class="fs-4 bi-speedometer2 nav-icon fas fa-sign-out-alt"> </i>
                              <span class="ms-2 d-none d-sm-inline">Logout</span>
                              
                               </a>
                        
                    </li>
                    
                </ul>
             <!--   <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
                 
                    <li v-for="(item, index) in Menu" v-bind:key="item" v-bind:index="index"   data-bs-toggle="collapse">
                        <a v-bind:href="'#'+item.nidOpcionesSistemas"  data-bs-toggle="collapse" class="nav-link px-0 align-middle">
                            <i v-bind:class="['fs-4 bi-speedometer2 nav-icon', item.sIcon]"> ></i>
                             <span class="ms-1 d-none d-sm-inline">{{item.sDescripcionOpcion}}</span> </a>

                        <ul class="collapse show nav flex-column ms-1" 
                        v-for="(subitem, subindex) in item.olDet" v-bind:key="subitem" v-bind:index="subindex"
                         data-bs-parent="#menu">
                            <li class="w-100" v-bind:id="subitem.nIdParent">
                               <router-link class="nav-link px-0" v-bind:to="subitem.sUrlVista" > 
                                    <i  v-bind:class="['fs-4 bi-speedometer2 nav-icon', subitem.sIcon]"> </i>
                                   <span class="d-none d-sm-inline">{{subitem.sDescripcionOpcion}}</span> </router-link>
                            </li>
                           
                        </ul>
                        
                    </li>
                   
                </ul> 
                <hr>
                <div class="dropdown pb-4">
                    <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                        <img src="https://github.com/mdo.png" alt="hugenerd" width="30" height="30" class="rounded-circle">
                        <span class="d-none d-sm-inline mx-1">loser</span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
                        <li><a class="dropdown-item" href="#">New project...</a></li>
                        <li><a class="dropdown-item" href="#">Settings</a></li>
                        <li><a class="dropdown-item" href="#">Profile</a></li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li><a class="dropdown-item" @click="Logout()">Sign out</a></li>
                    </ul>
                </div> -->
            </div>
           
        

</template>
<script>

export default {
  name: "Menu",
  props: ["content"],
  data: function () {
    return {
    Menu:[],  

    }
  },
  mounted(){

    let ipmenu = this.$store.state.menu;
    this.axios
        .get(ipmenu + "/Menu", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Menu = response.data.olCabecera;
     
          })
        .catch(error => {
          //console.log('err',error.response.status);
          if(error.response.status === 401) {
              this.content.token=false;
              localStorage.removeItem('token');
              this.$router.push('/');   
          }
        });
  },
  methods: {
      
      Logout(){
          this.content.token=false;
          localStorage.removeItem('token');
          this.$router.push('/'); 
      }
  },
};
</script>
